import axiosInstance from '../utils/axios-instance';
import {
	CUMasterType,
	CUCombinationType,
	CUMaterialMappingType,
	CUProductTypeMappingType,
	CUDepartmentMappingType,
	CUCertificateAdditionalDocumentType,
	CUMaterialRequestType,
	CUProductTypeRequestType,
	CUDepartmentRequestType,
} from '../types/cu.types';
import { PostResponse } from '../types/common.types';

// #region GET
export const getCUMaster = async (): Promise<CUMasterType> => {
	const url: string = `/BrandScopeCertificate/GetCUMaster`;
	return axiosInstance.get(url);
};

export const getMaterialCombination = async (): Promise<CUCombinationType[]> => {
	const url: string = `/BrandScopeCertificate/GetAllCUMaterialCombination`;
	return axiosInstance.get(url);
};

export const getMaterialMapping = async (): Promise<CUMaterialMappingType[]> => {
	const url: string = `/BrandScopeCertificate/GetAllMaterialMapping`;
	return axiosInstance.get(url);
};

export const getProductTypeMapping = async (): Promise<CUProductTypeMappingType[]> => {
	const url: string = `/BrandScopeCertificate/GetAllProductTypeMapping`;
	return axiosInstance.get(url);
};

export const getDepartmentMapping = async (): Promise<CUDepartmentMappingType[]> => {
	const url: string = `/BrandScopeCertificate/GetAllDepartmentMapping`;
	return axiosInstance.get(url);
};

export const getCertificateAdditionalDocuments = async (): Promise<CUCertificateAdditionalDocumentType[]> => {
	const url: string = `/BrandScopeCertificate/GetAllCertificateAdditionalDocument`;
	return axiosInstance.get(url);
};

export const getCUBlobSasToken = async (): Promise<string> => {
	const url: string = `/BrandScopeCertificate/GetBlobSasToken`;
	return axiosInstance.get(url);
};

export const downloadCUFile = async (blobPath: string, fileName: string): Promise<any> => {
	const url: string = `/BrandScopeCertificate/Download?blobPath=${blobPath}&fileName=${fileName}`;
	return axiosInstance.get(url, {
		responseType: 'blob',
	});
};

// #region POST
export const saveMaterialMapping = async (request: CUMaterialRequestType): Promise<PostResponse> => {
	const url: string = `/BrandScopeCertificate/SaveMaterialMapping`;
	return await axiosInstance.post(url, request);
};

export const saveProductTypeMapping = async (request: CUProductTypeRequestType): Promise<PostResponse> => {
	const url: string = `/BrandScopeCertificate/SaveProductTypeMapping`;
	return await axiosInstance.post(url, request);
};

export const saveDepartmentMapping = async (request: CUDepartmentRequestType): Promise<PostResponse> => {
	const url: string = `/BrandScopeCertificate/SaveDepartmentMapping`;
	return await axiosInstance.post(url, request);
};

export const saveCertificateAdditionalDocument = async (saveRequest: FormData): Promise<PostResponse | any> => {
	const url: string = `/BrandScopeCertificate/SaveCertificateAdditionalDocument`;
	return axiosInstance.post(url, saveRequest, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	});
};

export const deleteCertificateAdditionalDocument = async (
	recordId: string,
	blobPath: string,
	fileName: string
): Promise<PostResponse | any> => {
	const url: string = `/BrandScopeCertificate/Delete?recordId=${encodeURIComponent(
		recordId
	)}&blobPath=${encodeURIComponent(blobPath)}&fileName=${encodeURIComponent(fileName)}`;
	return axiosInstance.delete(url);
};
